<template>
  <div>
    <v-container>
      <h1 class="text-h4 light--text font-weight-light">Oops.</h1>
      <h1 class="text-h5 light--text font-weight-light">
        This link has expired or does not exist.
      </h1>
      <h1 class="text-h6 lightGreen--text font-weight-light">
        Please
        <a
          href="https://ubinter.net/index.html#contactform"
          class="lightBlue--text"
          >contact us</a
        >
        for a new link.
      </h1>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>